<template>
    <div>
        <el-dialog
                :title="title"
                :visible.sync="show"
                :width="curTab=='serve'?'800px':'1200px'" >
            <div class="w100 pl20 pr20 pb20" v-loading="loading">
                <div class="table-con h400p">
                    <el-table v-if="curTab=='serve'" class="w100 mt20 table" header-row-class-name="table-head"
                              row-class-name="cu-p" stripe :data="list" height="100%">
                        <el-table-column align="center"  prop="createUser" label="发起人"></el-table-column>
                        <el-table-column align="center" prop="costTime" label="处理时间（h）">
                            <template slot-scope="scope">
                                <span>{{(scope.row.costTime/3600).toFixed(2)}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center"   prop="processStatus" label="状态">
                            <template slot-scope="scope">
                                <div :class="{'underway':scope.row.processStatus=='进行中'}"
                                     v-if="scope.row.processStatus=='进行中'">
                                    {{scope.row.processStatus}}</div>
                                <div :class="{'accomplish':scope.row.processStatus=='已完成'}"
                                     v-else-if="scope.row.processStatus=='已完成'">
                                    {{scope.row.processStatus}}</div>
                                <div v-else>
                                    {{scope.row.processStatus}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-table v-if="curTab=='dept'" class="w100 mt20 table" header-row-class-name="table-head"
                              row-class-name="cu-p" stripe :data="list" height="100%">
                        <el-table-column align="center"  prop="serveName" label="服务名称"></el-table-column>
                        <el-table-column align="center" label="办理次数">
                            <template slot-scope="scope" >
                                <span >{{scope.row.applyNum}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center"  label="结办次数">
                            <template slot-scope="scope" >
                                <span >{{scope.row.finNum}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="结办率">
                            <template slot-scope="scope" >
                                <span v-if="!!scope.row.applyNum">{{(scope.row.finNum*100/scope.row.applyNum).toFixed(2)+'%'}} </span>
                                <span v-else>0.00%</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120px"  prop="maxCost" label="最长时效（h）">
                            <template slot-scope="scope">
                                <span class="color-blue">{{(scope.row.maxCost/3600000).toFixed(2)}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120px"  prop="minCost" label="最短时效（h）">
                            <template slot-scope="scope">
                                <span  class="color-blue">{{(scope.row.minCost/3600000).toFixed(2)}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120px"  label="平均时效（h）">
                            <template slot-scope="scope" >
                                <span v-if="!!scope.row.finNum"  class="color-blue">{{(scope.row.sumCost/scope.row.finNum/3600000).toFixed(2)}} </span>
                                <span v-else>0.00</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="200px" prop="wew"   label="好差评">
                            <template slot-scope="scope">
                                <el-rate :value="Number(scope.row.avgPoints)" disabled></el-rate>
                            </template>
                        </el-table-column>
                        <el-table-column align="center"  label="操作">
                            <template slot-scope="scope">
                                <div class="to-use">
                                    <span class="info" @click="openDetail(scope.row)">查看详情</span>
                                </div>
                            </template>
                        </el-table-column>
                        <!--<el-table-column align="center"  label="操作">-->
                            <!--<template slot-scope="scope">-->
                                <!--<div class="to-use">-->
                                    <!--<span class="info" style="color:#689EFF" @click="openDetail(scope.row)">详情</span>-->
                                <!--</div>-->
                            <!--</template>-->
                        <!--</el-table-column>-->
                    </el-table>
                    <el-table v-if="curTab=='personal'" class="w100 mt20 table" header-row-class-name="table-head"
                              row-class-name="cu-p" stripe :data="list" height="100%">
                        <el-table-column align="center"  prop="serveName" label="服务名称"></el-table-column>
                        <el-table-column align="center" label="办理次数">
                            <template slot-scope="scope" >
                                <span >{{scope.row.applyCount}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center"  label="结办次数">
                            <template slot-scope="scope" >
                                <span >{{scope.row.endCount}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="结办率">
                            <template slot-scope="scope" >
                                <span >{{scope.row.endRatio}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120px"  prop="maxTime" label="最长时效（h）">
                            <template slot-scope="scope">
                                <span class="color-blue">{{(scope.row.maxTime/3600000).toFixed(2)}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120px"  prop="minTime" label="最短时效（h）">
                            <template slot-scope="scope">
                                <span  class="color-blue">{{(scope.row.minTime/3600000).toFixed(2)}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="120px"  label="平均时效（h）">
                            <template slot-scope="scope" >
                                <span  class="color-blue">{{(scope.row.avgTime/3600000).toFixed(2)}} </span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" width="200px" prop="wew"   label="好差评">
                            <template slot-scope="scope">
                                <el-rate :value="Number(scope.row.avgPoints)" disabled></el-rate>
                            </template>
                        </el-table-column>
                        <el-table-column align="center"  label="操作">
                            <template slot-scope="scope">
                                <div class="to-use">
                                    <span class="info" @click="openDetail(scope.row,'personal')">查看详情</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 当前待办排行详情 -->
                    <el-table v-if="curTab=='nowSort'" class="w100 mt20 table" header-row-class-name="table-head"
                              row-class-name="cu-p" stripe :data="list" height="100%">
                        <el-table-column align="center"  prop="username" label="名称" width="120"></el-table-column>
                        <el-table-column align="center"  prop="time" label="创建时间" width="160">
                            <template slot-scope="scope">
                                {{ scope.row.time }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center"  prop="bpmName" label="部门" width="260">
                            <template slot-scope="scope">
                                {{ scope.row.bpmName }}
                            </template>
                        </el-table-column>
                        <el-table-column align="center"  prop="text" label="服务名称">
                            <template slot-scope="scope">
                                {{ scope.row.text }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column align="center"  label="操作">
                            <template slot-scope="scope">
                                <div class="to-use">
                                    <span class="info" @click="openDetail(scope.row,'personal')">查看详情</span>
                                </div>
                            </template>
                        </el-table-column> -->
                    </el-table>
                </div>

                <div class="mt20 flex-box">
                    <div class="flex-1"></div>
                    <el-pagination background @size-change="changeSize"
                                   @current-change="changePage"
                                   :current-page="paramSearch.current"
                                   :page-sizes="pageSizes"
                                   :page-size="paramSearch.size"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="total"
                    ></el-pagination>
                </div>


            </div>
            </el-dialog>
        <detailShowTwo ref="detailShowTwo"></detailShowTwo>
    </div>
</template>

<script>
    import {
        bpmnPageServeDetailProcess,
        bpmnPageDeptStastic,
        bpmnPageServeStastic,
        pagePersonalStasticDetail,
        pageNowSortStasticDetail,
    } from '@/api/bpmnApi/bpmn';
    import detailShowTwo from "@/views/statistical/all/detailShowTwo";
    export default {
        name: "detailShow",
        components: {
            detailShowTwo
        },
        data() {
            return {
                show: false,
                loading: false,
                title:'',
                list:[],
                total:0,
                pageSizes:[10, 20, 30, 50, 100],
                paramSearch:{
                    current:1,
                    size:10
                },

                time:{
                    beginTime:'',
                    endTime:'',
                    processDefId:'',
                    deptId:'',
                },
                curTab:''

            };
        },
        computed: {

        },
        methods: {
            bpmnPageServeDetailProcessFn(){
                let params={
                    ...this.time,
                    ...this.paramSearch
                }
                console.log(params)
                let method
                if(this.curTab=='serve'){
                    delete params.deptId;
                    method= bpmnPageServeDetailProcess;
                }
                if(this.curTab=='dept'){
                    delete params.processDefId;
                    method= bpmnPageServeStastic;
                }
                if(this.curTab=='personal'){
                    delete params.deptId;
                    delete params.processDefId;
                    method= pagePersonalStasticDetail;
                }

                if(this.curTab=='nowSort'){
                    delete params.deptId;
                    delete params.processDefId;
                    method= pageNowSortStasticDetail;
                }

                this.loading=true;
                method(params).then(({data})=>{
                    this.loading=false;
                    if(data.code==0){
                        this.list=data.data.records||[]
                        this.total = data.data.total;
                    }
                    }).catch(err=>{
                        this.loading=false;
                    })

            },
            // 条数
            changeSize(value) {
                this.paramSearch.size=value;
                this.paramSearch.current=1;
                this.bpmnPageServeDetailProcessFn();
            },
            // 翻页
            changePage(value) {
                this.paramSearch.current=value;
                this.bpmnPageServeDetailProcessFn();
            },
            // 显示弹框
            dialogShow (item,params,curTab) {
                console.log(item)
                this.paramSearch={
                    current:1,
                        size:10
                };
                this.show=true;// 显示弹框
                this.curTab=curTab;
                this.time.beginTime=params.beginTime;
                this.time.endTime=params.endTime;
                if(curTab=='serve'){
                    this.time.processDefId=item.processDefId;
                    this.title="【"+item.serveName+"】 服务效能详情"
                }
                if(curTab=='dept'){
                    this.time.deptId=item.deptId;
                    this.title="【"+item.deptName+"】 效能详情"
                }
                if(curTab=='personal'){
                    this.time.userId=item.userId
                    this.title="【"+item.username+"】 服务效能详情"
                }
                if(curTab=='nowSort'){
                    this.time.userId=item.userId
                    this.title="【"+item.username+"】 待办排行详情"
                }
                this.bpmnPageServeDetailProcessFn();

            },
            openDetail(item,name){
                if(name="personal"){
                    item.userId = this.time.userId
                    this.$refs.detailShowTwo.dialogShow(item,this.time,'personal')
                }else{
                    this.$refs.detailShowTwo.dialogShow(item,this.time,'serve')
                }
            },

        },
        watch:{
            show(flag){
                if(!flag){
                    this.list=[];
                }

            }
        },
        filters: {}
    };
</script>

<style scoped lang="less">
    .to-use span.info{
        display: inline-block;
        font-size: 14px;
        width: 70px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        cursor: pointer;
        background: #49A4F0;
        color: white;
    }
.underway{
    color: #9AE060;
}
    .accomplish{
        color: orangered;
    }
</style>

